import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DataEntryPerformanceSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      <div className="py-2 px-4 border-b border-gray-200 flex justify-between items-center">
        <Skeleton width={150} height={20} />
        <Skeleton width={100} height={28} />
      </div>

      <div className="divide-y divide-gray-200 max-h-[400px] overflow-y-auto">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="py-2 px-4 hover:bg-gray-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Skeleton
                  circle
                  height={32}
                  width={32}
                  containerClassName="flex-shrink-0"
                />
                <div className="ml-3">
                  <Skeleton width={100} height={16} />
                </div>
              </div>
              <Skeleton width={60} height={24} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataEntryPerformanceSkeleton;
